module.exports = __webpack_public_path__ + "static/media/aboutPagesContent.db2efa89.yaml";